module.exports = "/_next/static/images/PurpleBanner-min-211bad29efa4795a90ffd3b150725420.jpg";